var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7.5,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 15,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 7.5,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 5,
    height: 5,
    fill: "#E0E0E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreApplication);
export default __webpack_public_path__ + "static/media/more-application.44f63d4c86e8125aa24e973738308aad.svg";
export { ForwardRef as ReactComponent };